module.exports = __webpack_public_path__ + "media/5-z.7d86cd65.wav";